import React from 'react'
import { AlertTriangle } from 'lucide-react'

// GraceBanner (FE4) — the AMBER warning shown when a payment has failed but the account is still
// inside its 5-day grace window (subscription_status past_due, grace not yet expired). It is a
// RECOVERABLE state: rates keep publishing until grace ends, so the tone is amber (warning), not
// rose (frozen). The grace-end date arrives pre-localisable from the backend — no client-side
// date math, no money math. Distinct tone from TrialBanner (teal) and LapsedBanner (rose) so the
// customer can read severity from colour alone.
export default function GraceBanner({ graceEndsAtIso }: { graceEndsAtIso: string | null }) {
  const formatted = graceEndsAtIso
    ? new Date(graceEndsAtIso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
    : null

  return (
    <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 shadow-sm">
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-500" />
      <div className="text-sm">
        <p className="font-semibold text-amber-800">A payment failed</p>
        <p className="mt-0.5 text-amber-700">
          {formatted ? (
            <>
              Update your card before <span className="font-semibold tabular-nums">{formatted}</span> to keep rates
              publishing to your PMS. After that, rate pushes are paused until billing is restored.
            </>
          ) : (
            <>Update your card to keep rates publishing to your PMS. Rate pushes pause once the grace period ends.</>
          )}
        </p>
      </div>
    </div>
  )
}
